import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../reducers';
import { isDefined } from '@energybox/react-ui-library/dist/utils';
import {
  unsubscribeFromWorkerStatus,
  subscribeToWorkerStatus,
} from '../actions/streamApi';
import { ReportStatusById } from '../reducers/subscribeReport';

const useSubscribeToReportStatus = () => {
  const dispatch = useDispatch();
  const [jobIds, setJobIds] = useState([]);
  const previousJobIdsRef = useRef([]);

  const reportWorker = useSelector(
    ({ reportworker }: ApplicationState) => reportworker.reportWorker
  );

  useEffect(() => {
    if (reportWorker && reportWorker.length) {
      setJobIds(reportWorker.map(data => data.jobId));
    }
  }, [reportWorker]);

  useEffect(() => {
    if (isDefined(jobIds)) {
      const currentJobIds = Array.isArray(jobIds) ? jobIds : [jobIds];
      const previousJobIds = previousJobIdsRef.current;
      const newJobIds = currentJobIds.filter(
        jobId => !previousJobIds.includes(jobId)
      );
      const removedJobIds = previousJobIds.filter(
        jobId => !currentJobIds.includes(jobId)
      );

      newJobIds.forEach(jobId => {
        dispatch(subscribeToWorkerStatus(jobId));
      });
      removedJobIds.forEach(jobId => {
        dispatch(unsubscribeFromWorkerStatus(jobId));
      });

      previousJobIdsRef.current = currentJobIds;
    }
  }, [dispatch, jobIds]);

  const subscribedReportStatusById = useSelector<
    ApplicationState,
    ReportStatusById | undefined
  >(({ subscribedReportWorker }) => {
    return subscribedReportWorker.reportStatusById;
  });

  return subscribedReportStatusById;
};

export default useSubscribeToReportStatus;
